var map = {
	"./banner-default.jpg": "b22d",
	"./banners/reach-banner-1.jpg": "9ae0",
	"./banners/reach-banner-2.jpg": "86bd",
	"./banners/reach-banner-3.jpg": "d683",
	"./partners/cool-ideas.png": "3358",
	"./partners/fly-cool-internet.png": "a4fa",
	"./partners/home-connect.png": "2fb4",
	"./partners/hypa.jpg": "1d49",
	"./partners/mweb.png": "963a",
	"./partners/sa-digital-villages.jpg": "a655",
	"./partners/vodacom.png": "8fdd",
	"./reach-default.jpg": "4064",
	"./tabs/reach-connect.jpg": "0b94",
	"./tabs/reach-entertainment.jpg": "d83d",
	"./tabs/reach-save.jpg": "e7311",
	"./tabs/reach-work.jpg": "cf19",
	"./vuma-reach-banner.jpg": "3939"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d786";